import { FloatingCard } from '@/components/FloatingCard';
import Loader from '@/components/Loader';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    title: string;
    loading: boolean;
    onClick: Function;
}

export const DownloadCertificate = ({ title, loading, onClick }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    return (
        <FloatingCard>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <span>{title}</span>
                    <button className="btn btn-primary" onClick={() => onClick()}>
                        <i className="material-icons align-middle">{Constants.icons.VERIFIED}</i>
                        <span>{strings.DOWNLOAD_CERTIFICATE}</span>
                    </button>
                </>
            )}
        </FloatingCard>
    );
};
